/* eslint-disable react-hooks/exhaustive-deps */
import { useGlobalStore } from "@/store/GlobalStore";
import { Form, Tooltip } from "@renderbus/ui";
import { ValidatorRule } from "rc-field-form/lib/interface";
import { useEffect, useMemo, useState } from "react";
import useForm from "antd/es/form/hooks/useForm";
import { useClientTopUpStore } from "../../store";
import {
  ChangeCouponCode,
  CouponCodeTipWrapper,
  CustomTooltipStyle,
  RechargeForm,
} from "./atom";
import { Input, Space } from "task-eva-ui";
import { CommonTitle } from "../../atom";
import {
  CouponCodeTipList,
  initVerifyRechargeInfo,
  TipType,
} from "../../constants";
import CloseIcon from "@/assets/icons/topup/close-code";
import InfoIcon from "@/assets/icons/topup/info";
import { couponTypeTranslate } from "@/components/top-up/help/couponTypeTranslate";

export function RechargeInputForm() {
  const { currencySymbol } = useGlobalStore();
  const [currentInputAmount, setCurrentInputAmount] = useState("");
  const {
    rechargeAmount,
    setRechargeAmount,
    setIsCheckCard,
    verifyRechargeInfo,
    setVerifyRechargeInfo,
    setInputCode,
  } = useClientTopUpStore();
  const [form] = useForm();
  const {
    couponNO,
    rechargeAmount: verifyRechargeAmount,
    couponAmount,
    couponType,
  } = verifyRechargeInfo;

  const couponCodeTip = useMemo(
    () =>
      rechargeAmount >= Number(verifyRechargeAmount)
        ? CouponCodeTipList[TipType.Satisfied]
        : CouponCodeTipList[TipType.NotSatisfied],
    [rechargeAmount, CouponCodeTipList]
  );

  const validator: ValidatorRule["validator"] = (_, value) => {
    const num = Number(value);
    if (Number.isNaN(num)) {
      return Promise.reject("请输入数字");
    } else if (!num) {
      return Promise.reject("必填");
    } else if (num < 5) {
      return Promise.reject("请输入5.00-200000.00之间数值");
    } else if (num < 0) {
      return Promise.reject("请输入正整数");
    } else {
      return Promise.resolve();
    }
  };

  const limitAmount = (value: any) => {
    if (!value || value === "0") return value;
    const amount = value.replace(
      // eslint-disable-next-line no-useless-escape
      /^(\-)*(\d+)\.(\d\d).*$/,
      "$1$2.$3"
    );
    const tempData = [...amount.toString()];
    if (!/^[^.]/.test(amount)) {
      tempData.unshift("0");
      setCurrentInputAmount(tempData.join(""));
      return tempData.join("");
    } else if (/^0\d*$/.test(amount) && amount.length > 1) {
      tempData.shift();
      setCurrentInputAmount(tempData.join(""));
      return tempData.join("");
    } else if (amount > 200000) {
      return currentInputAmount;
    } else if (amount && amount === "0.00") {
      tempData.pop();
      setCurrentInputAmount(tempData.join(""));
      return tempData.join("");
    } else {
      setCurrentInputAmount(amount);
      return amount;
    }
  };

  const limitKeyDown = (e: any) => {
    if (
      !(
        (e.key >= "0" && e.key <= "9") ||
        e.key === "Backspace" ||
        e.key === "Delete" ||
        e.key === "." ||
        e.key === "ArrowLeft" ||
        e.key === "ArrowRight"
      )
    ) {
      e.preventDefault();
      return false;
    }
    return true;
  };

  const onInput = (val: number) => {
    setRechargeAmount(val);
    setIsCheckCard(false);
  };

  const preventWheel = (e: any) => {
    e.preventDefault();
  };

  const onPasteChange = (event: any) => {
    event.preventDefault();
  };

  const handleChange = (val: string) => {
    setVerifyRechargeInfo(initVerifyRechargeInfo);
    setInputCode("");
  };

  useEffect(() => {
    form.setFieldsValue({ amount: rechargeAmount });
  }, [rechargeAmount]);

  useEffect(() => {
    // 防止滚轮滚动的自增自减
    const inputElement = document.querySelector(".client-amount-input input");
    if (inputElement) {
      inputElement.addEventListener("wheel", preventWheel, { passive: false });
    }
    return () => {
      if (inputElement) {
        inputElement.removeEventListener("wheel", preventWheel);
      }
    };
  }, []);

  return (
    <RechargeForm form={form}>
      <CommonTitle>其他金额</CommonTitle>
      <Space gap={14} align={"baseline"}>
        <Form.Item
          name="amount"
          rules={[{ validator }]}
          getValueFromEvent={(event: any) => {
            return limitAmount(event.target.value);
          }}
        >
          <div className="client-amount-input">
            <Input
              prefix={currencySymbol}
              type={"number"}
              value={rechargeAmount}
              background="#212327"
              pattern="[0-9]*"
              onKeyDown={limitKeyDown}
              onPaste={onPasteChange}
              onInput={(e) => onInput?.(limitAmount(e.currentTarget.value))}
              placeholder={"自定义充值金额"}
            />
          </div>
        </Form.Item>
        {couponNO && (
          <ChangeCouponCode>
            <div>{couponNO}</div>
            <div className="change-btn" onClick={() => handleChange(couponNO)}>
              <CloseIcon />
            </div>
          </ChangeCouponCode>
        )}
      </Space>
      {couponNO && (
        <>
          <CouponCodeTipWrapper titleColor={couponCodeTip.titleColor}>
            {couponCodeTip.icon}
            <span className="pre-title">{couponCodeTip.preTitle}</span>
            <span className="gift-tip">额外福利</span>
            <span>
              充值满{verifyRechargeAmount}元，额外赠送{couponAmount}元
              {couponTypeTranslate(couponType || 3)}
            </span>
          </CouponCodeTipWrapper>
          <Tooltip
            title={"充值成功后可前往个人中心-渲染券查看"}
            className="info-tooltip"
            tooltipText={<InfoIcon className="info-icon" />}
          />
        </>
      )}
      <CustomTooltipStyle />
    </RechargeForm>
  );
}
